import { LocalCart } from "types/localCart"
import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"

export const useCartStorage = create<LocalCart>()(
  persist(
    (set) => ({
      items: [],

      addItem: (variantID, count, productTitle, productCode, unit, price) =>
        set((state) => ({
          items: [
            ...state.items,
            { variantID, count, productTitle, productCode, unit, price },
          ],
        })),
      removeItem: (variantID) =>
        set((state) => ({
          items: [...state.items.filter((item) => item.variantID != variantID)],
        })),
      changeAmount: (variantID, newCount) =>
        set((state) => ({
          items: state.items.map((item) =>
            item.variantID == variantID ? { ...item, count: newCount } : item
          ),
        })),
      clearCart: () => set(() => ({ items: [] })),
      setItems: (items) => set(() => ({ items: items })),
    }),
    {
      name: "medusa-local-cart",
      storage: createJSONStorage(() => localStorage),
    }
  )
)
